import { addressBookStyles } from "@insite/content-library/Widgets/Addresses/AddressBook";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import { COLORS, TYPOGRAPHY } from "@tecumseh/theme/design";
import { css } from "styled-components";

addressBookStyles.addressCard = {
    actionUseAsShippingAddressButton: {
        css: css`
            border-radius: 25px;
            border: 1px solid ${getColor("warning")};
            background-color: ${getColor("warning")};
            > span {
                color: ${getColor("info.contrast")} !important;
                font-family: ${TYPOGRAPHY.fontFamily.base};
            }
            &:hover {
                border: 1px solid ${getColor("warning.contrast")};
                background-color: ${getColor("warning.contrast")};
            }
            &:disabled:hover {
                border: 1px solid ${COLORS.disabled.base};
                background-color: ${COLORS.disabled.base};
            }
        `,
    },
    gridContainer: { gap: 30 },
    addressInfoDisplayGridItem: {
        width: [10, 10, 5, 7, 7],
    },
    addressInfoDisplay: {
        wrapper: {
            css: css`
                font-style: normal;
                font-size: ${TYPOGRAPHY.size.smaller} !important;
            `,
        },
    },
    actionsGridItem: {
        width: [2, 2, 7, 5, 5],
        css: css`
            justify-content: flex-end;
        `,
    },
    actionEditLink: {
        css: css`
            display: block;
            margin: 10px auto 0 auto;
            span {
                color: ${getColor("primary")}!important;
            }
        `,
    },
    bottomBorderGridItem: { width: 12 },
    bottomBorder: {
        css: css`
            height: 1px;
            background-color: ${getColor("common.border")};
            width: 100%;
        `,
    },
    overflowMenu: {
        cssOverrides: {
            menu: css`
                width: 210px;
            `,
        },
    },
};
